<script>
	import { getContext, onDestroy, onMount } from 'svelte'
	import { url } from '../scripts/Setup.svelte'
	import { flip } from 'svelte/animate'
	import { styles } from '../scripts/styles'
	import {
		storeElementID,
		storeData,
		storeShowTools,
		storeBuilderPreview,
		storeAnimate,
		storeExpand,
	} from '../scripts/Store.svelte'
	import * as animateScroll from 'svelte-scrollto'
	import Shader from '../ShadersAndSpinners/Shader.svelte'
	import Spinner from '../ShadersAndSpinners/SpinnerCircle.svelte'
	import ExpandText from '../LayoutStuff/ExpandText.svelte'
	import IntersectionObserver from 'svelte-intersection-observer'

	export let content
	export let showText = 'true'
	export let control = 'grey'
	export let controlHover = 'green'

	//observer
	let element
	let large = false
	const set_observer = (e) => {
		if (e === 'set') {
			large = false
			element.style.filter = 'blur(5px)'
		} else {
			large = true
			element.style.filter = 'blur(0px)'
		}
	}

	//get configFile from storeData
	let configFile
	let data
	let images = []
	let showTools
	let showPreview
	let autoplay
	let path
	let thumbPath
	let textSize
	let titleSize

	//get configFile from storeData
	let transitionSpeed
	let transitionPause
	const stoData = storeData.subscribe((value) => {
		if (value) {
			configFile = value
			data = value.blocks

			data.forEach((item) => {
				if (item.blockName === 'cover-slider') {
					transitionSpeed = item.sliderSpeed
					transitionPause = item.sliderPause
					autoplay = item.sliderAutoPlay
					textSize = item.sliderInsetTextSize
					titleSize = item.sliderInsetTitleSize
					control = item.controlC
					controlHover = item.controlH
				}
			})
			storeAnimate.set(autoplay)
		}
	})

	const globals = getContext('globals')
	const fsXS = globals.fsXS
	const fsS = globals.fsS
	const fsN = globals.fsN
	const fsL = globals.fsL
	const devWidth = globals.devWidth
	const isMobi = globals.mobi
	const builderToolbar = globals.builderToolbar
	const builderToolbarHover = globals.builderToolbarHover

	//the folder from which to take images
	let folder

	if (!isMobi) {
		if (devWidth >= 1440) folder = '/large/'
		if (devWidth < 1440 && devWidth >= 800) folder = '/medium/'
		if (devWidth < 800) folder = '/small/'
	}

	// mobile devices
	if (isMobi) {
		if (devWidth < 1440 && devWidth >= 800) folder = '/medium/'
		else folder = '/small/'
	}

	//hide the tool pen if window.location is preview
	let showPen = true

	//responsive design (binding)
	let deviceWidth
	let deviceHeight

	//small devices
	$: if (deviceWidth <= 921) {
		textSize = fsXS
		titleSize = fsXS
	}

	$: if (deviceWidth <= 1120 && deviceWidth > 1148) {
		titleSize = fsN
		textSize = fsS
	}

	$: if (deviceWidth <= 1148 && deviceWidth > 1120) {
		textSize = fsN
	}

	$: if (deviceWidth <= 1660 && deviceWidth > 1148) {
		textSize = fsL
	}

	$: if (deviceWidth > 1660) textSize = textSize

	if (window.location.href.indexOf('preview') > -1) showPen = false
	const stoPreview = storeBuilderPreview.subscribe((value) => {
		showPreview = value
	})

	const stoAnimate = storeAnimate.subscribe((value) => {
		autoplay = value
	})

	const stoShowTools = storeShowTools.subscribe((value) => {
		showTools = value
	})

	let elementID = null
	const set_elementID = (e) => {
		storeShowTools.set(true)
		elementID = e
		storeElementID.set(e)
	}
	for (let key in content) {
		if (content[key].image) {
			path = url + '/cover-slider' + folder + content[key].image

			thumbPath = url + '/cover-slider/thumbnail' + '/' + content[key].image
		} else path = content[key].path
		images.push({
			path: path,
			thumbPath: thumbPath,
			name: 'slider' + content[key]['id'],
			id: 'sld' + content[key]['id'],
			title: content[key]['title'],
			text: content[key]['text'],
		})
	}

	//wait for transition to be finished
	let rotation = true
	let loaded = false

	//space for controls
	let space
	if (autoplay === 'true') space = '0%'
	if (autoplay === 'false') space = '20%'

	//timeouts
	let toLeft
	let toRight
	let toRotate
	let toInterval

	//get the commands for slider
	let direction
	$: data.forEach((item) => {
		if (item.blockName === 'cover-slider') {
			direction = item.sliderDirection
		}
	})

	data.forEach((item) => {
		if (item.blockName === 'cover-slider') {
			transitionSpeed = item.sliderSpeed
			transitionPause = item.sliderPause
			control = item.controlC
			controlHover = item.controlH
		}
	})

	const slide = (direction) => {
		if (rotation) {
			if (direction === 'left') {
				rotateLeft()
				rotation = false
			}
			if (direction === 'right') {
				rotateRight()
				rotation = false
			}
		}
		toRotate = setTimeout(() => {
			rotation = true
		}, transitionSpeed * transitionPause)
	}

	const rotateLeft = (e) => {
		const transitioningImage = images[images.length - 1]
		if (document.getElementById(transitioningImage.id) == null) return
		document.getElementById(transitioningImage.id).style.opacity = 0
		if (showText === 'true') document.getElementById(transitioningImage.name).style.opacity = 0
		images = [images[images.length - 1], ...images.slice(0, images.length - 1)]
		toLeft = setTimeout(() => {
			document.getElementById(transitioningImage.id).style.opacity = 1
			if (showText === 'true') document.getElementById(transitioningImage.name).style.opacity = 1
		}, transitionSpeed)
	}

	const rotateRight = (e) => {
		const transitioningImage = images[0]
		if (document.getElementById(transitioningImage.id) == null) return
		document.getElementById(transitioningImage.id).style.opacity = 0
		if (showText === 'true') document.getElementById(transitioningImage.name).style.opacity = 0
		images = [...images.slice(1, images.length), images[0]]
		toRight = setTimeout(() => {
			if (document.getElementById(transitioningImage.id) == null) return
			document.getElementById(transitioningImage.id).style.opacity = 1
			if (showText === 'true') document.getElementById(transitioningImage.name).style.opacity = 1
		}, transitionSpeed)
	}

	let animateFrame
	const animate = (time) => {
		if (direction === 'right') rotateLeft()
		if (direction === 'left') rotateRight()
		toInterval = setTimeout(() => {
			animateFrame = window.requestAnimationFrame(animate)
		}, transitionSpeed * transitionPause)
	}

	$: if (autoplay === 'true') animateFrame = window.requestAnimationFrame(animate)
	$: if (autoplay === 'false') window.cancelAnimationFrame(animateFrame)

	//expand text on small devices
	let expand
	const stoExpand = storeExpand.subscribe((value) => {
		expand = value
	})
	let imagePath = null
	let imageTitle = null
	let imageText = null
	const expand_text = (i, it, itxt) => {
		const slider = document.getElementById('coverslider')
		imagePath = i
		imageTitle = it
		imageText = itxt
		storeExpand.set(true)
		animateScroll.scrollTo({ y: parseInt(slider.offsetHeight) + parseInt(slider.offsetTop) })
	}

	const close_text = () => {
		const slider = document.getElementById('coverslider')
		storeExpand.set(false)
		animateScroll.scrollTo({ y: parseInt(slider.offsetTop) })
	}

	onMount(() => {
		loaded = true
		stoExpand
	})

	onDestroy(() => {
		stoData
		stoShowTools
		stoPreview
		stoAnimate
		clearTimeout(toLeft)
		clearTimeout(toRight)
		clearTimeout(toRotate)
		clearTimeout(toInterval)
		window.cancelAnimationFrame(animateFrame)
		stoExpand
	})
</script>

<svelte:window bind:innerWidth={deviceWidth} bind:innerHeight={deviceHeight} />
<IntersectionObserver
	{element}
	threshold="0.3"
	on:observe={(e) => {
		if (!e.detail.isIntersecting) {
			set_observer('set')
		} else {
			set_observer('unset')
		}
	}}
>
	{#if configFile}
		<main>
			{#each data as block}
				{#if block.blockName === 'cover-slider'}
					{#if !showPreview}
						<div
							class="content_row"
							use:styles={{ fsS, builderToolbar, builderToolbarHover }}
							on:click={() => set_elementID('cover-slider')}
							on:keydown={() => set_elementID('cover-slider')}
						>
							<div style="margin-left:20px;">*OPEN SLIDER TOOL*</div>
						</div>
					{/if}
					<div
						id="coverslider"
						style="
				position: relative;
				display: flex;
				justify-content: center;
				align-items: center;
				width: 100vw;
				height: {block.sliderHeight}vw;
				background-color:{block.backgroundColor};
				margin-top:{block.marginTop}%;
				margin-bottom:{block.marginBottom}%;
				padding:{block.padding}%
				"
					>
						<div
							class="container_inner"
							style="
						position: relative;
						display: flex;
						flex-direction: column;
						align-items: center;
						height: 100%;
						width: {block.sliderWidth}vw;
						"
						>
							{#if autoplay === 'false'}
								<div class="controls">
									<div class="controlLeft" style="height:{block.sliderHeight}vw">
										<div
											class="buttonLeft"
											use:styles={{ control, controlHover }}
											on:click={() => slide('left')}
											on:keydown={() => slide('left')}
										/>
									</div>

									<div class="controlRight">
										<div
											class="buttonRight"
											use:styles={{ control, controlHover }}
											on:click={() => slide('right')}
											on:keydown={() => slide('right')}
										/>
									</div>
								</div>
							{/if}
							<div
								bind:this={element}
								class="sliderWindow"
								style="
						position: relative;
						display: flex;
						justify-content: center;
						width: {block.sliderWidth}vw;
						height: 100%;
						overflow: hidden;
						border-left:{block.sliderBLwidth}px solid {block.sliderBLcolor};
						border-top:{block.sliderBTwidth}px  {block.sliderBTstyle} {block.sliderBTcolor};
						border-right:{block.sliderBRwidth}px {block.sliderBRstyle} {block.sliderBRcolor};
						border-bottom:{block.sliderBBwidth}px {block.sliderBBstyle} {block.sliderBBcolor};
						border-top-left-radius: {block.sliderBTradius}px;
						border-top-right-radius: {block.sliderBTradius}px;
						border-bottom-left-radius:  {block.sliderBBradius}px;
						border-bottom-right-radius:  {block.sliderBBradius}px;
						box-shadow: {block.sliderShadowOffsetX}px  {block.sliderShadowOffsetY}px {block.sliderShadowBlur}px {block.sliderShadowColor};
						"
							>
								{#if large}
									<div class="sliderContainer">
										{#each images as image (image.id)}
											<img
												style="
									height: 100%;
									width: {block.sliderWidth}vw;
									"
												animate:flip={{ duration: transitionSpeed }}
												src={image.path}
												id={image.id}
												alt={image.name}
											/>
										{/each}
									</div>
								{/if}

								{#if !large}
									<div class="sliderContainer">
										{#each images as image (image.id)}
											<img
												style="
									height: 100%;
									width: {block.sliderWidth}vw;
									"
												animate:flip={{ duration: transitionSpeed }}
												src={image.thumbPath}
												id={image.id}
												alt={image.name}
											/>
										{/each}
									</div>
								{/if}

								{#if showText === 'true'}
									<div
										id="csTxtContainer"
										style="
								position: absolute;
								display: flex;
								width: {block.sliderInsetWidth}%;
								height: {block.sliderInsetHeight}%;
								top: {block.sliderInsetTop}%;
								left: {block.sliderInsetLeft}%;
								justify-content: center;
								align-items: {block.blockTitleAlignVertical};
								color: {block.blockTitleColor};
								background-color: {block.sliderInsetBg};
								margin-top: {block.sliderInsetTop}%;
								border-top-left-radius : {block.sliderInsetBTradius}px;
								border-top-right-radius : {block.sliderInsetBTradius}px;
								border-bottom-left-radius: {block.sliderInsetBBradius}px;
								border-bottom-right-radius: {block.sliderInsetBBradius}px;
								border-left-width:{block.sliderInsetBLwidth}px;
								border-left-style:{block.sliderInsetBLstyle};
								border-left-color:{block.sliderInsetBLcolor};
								border-top-width:{block.sliderInsetBTwidth}px;
								border-top-style:{block.sliderInsetBTstyle};
								border-top-color:{block.sliderInsetBTcolor};
								border-right-width:{block.sliderInsetBRwidth}px;
								border-right-style:{block.sliderInsetBRstyle};
								border-right-color:{block.sliderInsetBRcolor};
								border-bottom-width:{block.sliderInsetBBwidth}px;
								border-bottom-style: {block.sliderInsetBBstyle};
								border-bottom-color:{block.sliderInsetBBcolor};
								overflow: hidden;
								box-shadow: {block.sliderInsetShadowOffsetX}px {block.sliderInsetShadowOffsetY}px {block.sliderInsetShadowBlur}px {block.sliderInsetShadowColor};
								"
									>
										{#each images as image (image.id)}
											<div
												style="
										min-width:100%;
										min-height:100%;
										font-family:{block.sliderInsetTextFont};
										color:{block.sliderInsetTextColor};
										font-size:{textSize};
										font-weight:{block.sliderInsetTextWeight};
										font-style:{block.sliderInsetTextStyle};
										"
												id={image.name}
												animate:flip={{ duration: transitionSpeed }}
											>
												{#if image.title || image.text}
													<div style="position:absolute;top:10%;width:100%;">
														{#if image.title}
															<div
																style="
												min-width: 100%;
												min-height:10%;
												text-align: center;
												margin-bottom: 2%;
												font-family:{block.sliderInsetTitleFont};
												color:{block.sliderInsetTitleColor};
												font-size:{titleSize};
												font-weight:{block.sliderInsetTitleWeight};
												font-style:{block.sliderInsetTitleStyle};
												margin:2% 0 2% 0;
												"
															>
																{image.title}
															</div>
														{/if}

														{#if image.text}
															<div
																style="
													min-width: 100%;
													min-height:80%;
													text-align: {block.sliderInsetTextAlign};
													font-family:{block.sliderInsetTextFont};
													color:{block.sliderInsetTextColor};
													font-size:{textSize};
													font-weight:{block.sliderInsetTextWeight};
													font-style:{block.sliderInsetTextStyle};
													padding: 0px 5% 0px 5%;
													white-space:pre-wrap;
													"
															>
																{#if deviceWidth < 700}
																	<div
																		on:click={() => expand_text(image.thumbPath, image.title, image.text)}
																		on:keydown={() => expand_text(image.thumbPath, image.title, image.text)}
																		style="display:flex;width:100%;justify-content: center;cursor:pointer;font-size:{fsS}"
																	>
																		expand text
																	</div>
																{:else}
																	{image.text}
																{/if}
															</div>
														{/if}
													</div>
												{/if}
											</div>
										{/each}
									</div>
								{/if}
							</div>
						</div>
					</div>
				{/if}
			{/each}
		</main>
	{/if}
</IntersectionObserver>

{#if expand}
	<ExpandText {imagePath} {imageTitle} {imageText} on:closewindow={close_text} />
{/if}

{#if !loaded}
	<Shader>
		<div slot="content">
			<Spinner color="hsl(0,0%,60%)" info="slider loading" />
		</div>
	</Shader>
{/if}

<style>
	.sliderContainer {
		display: flex;
	}

	.controls {
		position: absolute;
		top: 0px;
		left: 0px;
		display: flex;
		justify-content: space-between;
		align-items: center;
		width: 100%;
		height: 100%;
		z-index: 1;
	}
	.controlLeft,
	.controlRight {
		display: flex;
		align-items: center;
		width: clamp(1rem, 2vw, 1.8rem);
		height: 100%;
		margin-right: clamp(0.7rem, 1.3vw, 1rem);
		margin-left: clamp(0.7rem, 1.3vw, 1rem);
	}
	.buttonRight {
		width: 0;
		height: 0;
		border-top: clamp(0.7rem, 2vw, 1.8rem) solid transparent;
		border-bottom: clamp(0.7rem, 2vw, 1.8rem) solid transparent;
		border-left: clamp(0.7rem, 2vw, 1.8rem) solid var(--control);
		cursor: pointer;
	}
	.buttonLeft {
		width: 0;
		height: 0;
		border-top: clamp(0.7rem, 2vw, 2rem) solid transparent;
		border-bottom: clamp(0.7rem, 2vw, 2rem) solid transparent;
		border-right: clamp(0.7rem, 2vw, 2rem) solid var(--control);
		cursor: pointer;
	}
	.buttonRight:hover {
		border-left: clamp(0.7rem, 2vw, 2rem) solid var(--controlHover);
	}
	.buttonLeft:hover {
		border-right: clamp(0.7rem, 2vw, 2rem) solid var(--controlHover);
	}

	.content_row {
		display: flex;
		align-items: center;
		flex-wrap: wrap;
		width: 100%;
		cursor: pointer;
		font-style: italic;
		font-size: var(--fsS);
		background-color: var(--builderToolbar);
		height: 40px;
		border-bottom: 1px solid hsl(0, 0%, 50%);
	}

	.content_row:hover {
		background-color: var(--builderToolbarHover);
	}
</style>
